/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Result_Edit_RejectedInputs */



/**
* | output |
* | --- |
* | "Your change could not be applied, so nothing was sent" |
*
* @param {Chat_Tool_Result_Edit_RejectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_result_edit_rejected = /** @type {((inputs?: Chat_Tool_Result_Edit_RejectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Result_Edit_RejectedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihre Änderung konnte nicht übernommen werden, daher wurde nichts gesendet")
	return /** @type {LocalizedString} */ ("Your change could not be applied, so nothing was sent")
});